import React, { useEffect } from "react";
import AOS from "aos";
import SEO from "../SEO";
import "./About.css";

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  return (
    <>
      <SEO
        title="About MZR Software – Innovation & Expertise"
        description="Learn about MZR Software, our mission, team, and commitment to delivering innovative custom software solutions."
        image="https://mzrsoftware.com/assets/images/og-about.jpg"
        url="https://mzrsoftware.com/About/index"
      />

      <section id="about" className="about-section">
        {/* ================= H1 ================= */}
        <div className="container text-center mb-5" data-aos="fade-up">
          <h1 className="section-title">
            About <span className="highlight">MZR Software</span>
          </h1>
          <p className="section-subtitle">
            13+ Years of Experience in Custom Software, ERP & Digital Solutions
          </p>
        </div>

        {/* ================= INTRODUCTION ================= */}
        <div className="container mb-5" data-aos="fade-up">
          <h2>Introduction</h2>
          <p>
            MZR Software (Muhammad Zeeshan Rashid Software) is a Pakistan-based
            software development company founded in 2018. We specialize in ERP
            systems, POS software, web development, and custom enterprise
            solutions that help businesses automate operations and scale
            efficiently.
          </p>
        </div>

        {/* ================= FEATURES ================= */}
        <div className="container mb-5" data-aos="fade-up">
          <h2>Features</h2>

          <div className="row g-3">
            {[
              "Custom ERP & POS Development",
              "Web & E-Commerce Solutions",
              "Mobile App Development",
              "Cloud & Scalable Architecture",
              "Real-time Business Automation",
              "Secure & High Performance Systems",
            ].map((item, i) => (
              <div className="col-md-6" key={i}>
                <div className="feature-box">✓ {item}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ================= BENEFITS ================= */}
        <div className="container mb-5" data-aos="fade-up">
          <h2>Benefits</h2>

          <div className="row g-3">
            {[
              "Increase business efficiency",
              "Reduce manual workload",
              "Improve sales & inventory control",
              "Real-time reporting & analytics",
              "Scalable for future growth",
              "Affordable enterprise solutions",
            ].map((item, i) => (
              <div className="col-md-6" key={i}>
                <div className="feature-box">🚀 {item}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ================= SCREENSHOTS ================= */}
        <div className="container mb-5" data-aos="fade-up">
          <h2>Screenshots</h2>

          <div className="row g-4">
            <div className="col-md-4">
              <img
                src="/img/erp1.png"
                className="img-fluid rounded"
                alt="ERP Dashboard"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/img/pos1.png"
                className="img-fluid rounded"
                alt="POS System"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/img/web1.png"
                className="img-fluid rounded"
                alt="Website Project"
              />
            </div>
          </div>
        </div>

        {/* ================= INDUSTRIES ================= */}
        <div className="container mb-5" data-aos="fade-up">
          <h2>Industries</h2>

          <div className="row g-3">
            {[
              "Retail & Supermarkets",
              "Pharmacies",
              "Restaurants & Hotels",
              "Wholesale & Distribution",
              "Education Systems",
              "Corporate Enterprises",
            ].map((item, i) => (
              <div className="col-md-4" key={i}>
                <div className="industry-box">{item}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ================= FAQS ================= */}
        <div className="container mb-5" data-aos="fade-up">
          <h2>FAQs</h2>

          <div className="faq">
            <h5>Do you build custom ERP systems?</h5>
            <p>
              Yes, we build fully customized ERP systems based on business
              needs.
            </p>

            <h5>Do you offer POS software?</h5>
            <p>
              Yes, we provide fast and scalable POS systems for retail and
              restaurants.
            </p>

            <h5>Do you provide support?</h5>
            <p>Yes, we provide 24/7 support and maintenance services.</p>
          </div>
        </div>

        {/* ================= CTA ================= */}
        <div className="container text-center py-5" data-aos="fade-up">
          <h2>Ready to Build Your Software Solution?</h2>
          <p>Let’s automate your business with modern ERP & custom software.</p>

          <a
            href="https://wa.me/923351206586?text=Hi%20I%20need%20software%20solution"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            🚀 Get Free Consultation
          </a>
        </div>
      </section>
    </>
  );
}
